import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IAppData, IUsersList } from '../Infrastructure/Interfaces';
import axios from 'axios';

const UserDetailsInitialState: IAppData = {
    currentUser:{}
};

const UsersListInitialState: IUsersList = {
    loading: true,
    usersList: [],
  };

const UserDetailsSlice = createSlice({
    name: 'UserDetails',
    initialState: UserDetailsInitialState,
    reducers: {
        setUserDetails: (state, action) => {
            state.currentUser = action.payload
        }
    }
})

export const fetchUsersList = createAsyncThunk(
    'fetchUsersList',
    async () => {
      const baseurl = process.env.REACT_APP_RRD_OPTIMIZATION_BASE_URL as string;
  
      //const token = globalFetchToken(tokenurl, "", "5053");
          return axios
            .get(`${baseurl}/User/Users`, {
              headers: {
                Pragma: 'no-cache',
              },
            })
            .then(response => {
              if (response.data.success) {
                return response.data.result;
              }
            });
        }
  );
  
  const UsersListSlice = createSlice({
    name: 'usersList',
    initialState: UsersListInitialState,
    reducers: {},
    extraReducers: builder => {
      builder.addCase(fetchUsersList.fulfilled, (state, action) => {
        state.loading = false;
        state.usersList = action.payload;
      });
      builder.addCase(fetchUsersList.pending, (state, action) => {
        state.loading = true;
      });
      builder.addCase(fetchUsersList.rejected, (state, action) => {
        state.loading = false;
        state.usersList = [];
      });
    },
  });

export const UsersListReducer = UsersListSlice.reducer;

export const setUserDetails = UserDetailsSlice.actions;

export const UserDetailsReducer = UserDetailsSlice.reducer;